import { render } from "./RequestType.vue?vue&type=template&id=2658db66"
import script from "./RequestType.vue?vue&type=script&lang=js"
export * from "./RequestType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__